import Register from "./components/Register";
import Login from "./components/Login";
import Checkout from "./components/Checkout";
import Products from "./components/Products";
import Thanks from "./components/Thanks";
//import ipConfig from "./ipConfig.json";
import { Route, Switch } from "react-router-dom";

export const config = {
  endpoint: `https://rohini1jb-me-qkart-frontend-v2.onrender.com/api/v1`
};

function App() {
  return (
    <div className="App">         
       <Switch>
       <Route exact path="/thanks" component={Thanks} />
        <Route path="/checkout" component={Checkout} />
        <Route path="/register" component={Register} />
        <Route path="/login" component={Login} />
        <Route exact path="/" component={Products} />
      </Switch>
    </div>
  );
}
export default App;
